import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType, DemurrageTerms, DemurrageCountingType } from "__generated__/graphql";
import DemurrageCalculationMethodForm from "view/calculationmethods/components/form/DemurrageCalculationMethodForm";
import DemurrageCalculationMethodDetails from "view/calculationmethods/components/details/DemurrageCalculationMethodDetails";

export const DemurrageSchema: RegistryItem = {
	[CalculationMethodType.Demurrage]: {
		Form: DemurrageCalculationMethodForm,
		Details: DemurrageCalculationMethodDetails,
		fields: {
			"calculationMethod.demurrageTerms": { path: "demurrageTerms", rules: { required: true } },
			"calculationMethod.demurragePayableOver": {
				path: "demurragePayableOver",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageTerms === DemurrageTerms.Ttb2010,
				},
			},
			"calculationMethod.timeUnit": {
				path: "timeUnit",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageTerms === DemurrageTerms.PerContract,
				},
			},
			"calculationMethod.price": {
				path: "price",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageTerms === DemurrageTerms.PerContract,
				},
			},
			"calculationMethod.laytimeAllowed": {
				path: "laytimeAllowed",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageTerms === DemurrageTerms.PerContract,
				},
			},
			"calculationMethod.demurrageCountingType": {
				path: "demurrageCountingType",
				rules: {
					required: true,
				},
			},
			"calculationMethod.startCountingTime": {
				path: "startCountingTime",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageCountingType === DemurrageCountingType.StartCountingTime,
				},
			},
			"calculationMethod.workingHoursSinceNomination": {
				path: "workingHoursSinceNomination",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageCountingType === DemurrageCountingType.WorkingHoursSinceNomination,
				},
			},
			"calculationMethod.workingDaysSinceNomination": {
				path: "workingDaysSinceNomination",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.demurrageCountingType === DemurrageCountingType.WorkingDaysSinceNomination,
				},
			},
		},
		toInput: (form) => ({
			demurrageCalculationMethodInput: ({
				id: form.id,
				demurrageTerms: form.demurrageTerms,
				demurragePayableOver: form.demurragePayableOver,
				timeUnit: form.timeUnit,
				cargoQuantityUnit: form.cargoQuantityUnit,
				demurrageCountingType: form.demurrageCountingType,
				shortNotice: form.demurrageCountingType === DemurrageCountingType.ShortNotice,
				startCountingTime: form.startCountingTime,
				workingHoursSinceNomination: form.workingHoursSinceNomination,
				workingDaysSinceNomination: form.workingDaysSinceNomination,
				laytimeAllowed: form.laytimeAllowed,
				price: form.price,
				pricePerCargoQuantityUnit: form.pricePerCargoQuantityUnit,
			}),
		}),
		toForm: (method) => ({
			demurrageTerms: method.demurrageTerms ?? undefined,
			demurragePayableOver: method.demurragePayableOver ?? undefined,
			timeUnit: method.timeUnit ?? undefined,
			cargoQuantityUnit: method.cargoQuantityUnit ?? undefined,
			pricePerCargoQuantityUnit: method.pricePerCargoQuantityUnit ?? undefined,
			demurrageCountingType: method.demurrageCountingType ?? undefined,
			shortNotice: method.shortNotice ?? false,
			startCountingTime: method.startCountingTime ?? undefined,
			workingHoursSinceNomination: method.workingHoursSinceNomination ?? undefined,
			workingDaysSinceNomination: method.workingDaysSinceNomination ?? undefined,
			laytimeAllowed: method.laytimeAllowed ?? undefined,
		}),
	},
};
